export enum Environment {
  INT = 'INT',
  UAT = 'UAT',
  PROD = 'PROD',
}

export enum Region {
  EUROPE = 'EU',
  NORTH_AMERICA = 'NA',
  SOUTH_AMERICA = 'SA',
  ASIA = 'AS',
  AFRICA = 'AF',
  OCEANIA = 'OC',
}

export enum PageType {
  HP = 'HP',
  PLP = 'PLP',
  PDP = 'PDP',
  LP = 'LP',
  CART = 'cart',
  CHECKOUT = 'checkout',
  MY_ACCOUNT = 'myAccount',
}

export interface User {
  logged: boolean
  name: string
  mail: string
}

export interface Cart {
  url: string
  empty: boolean
  items: number
  value: number
}

export enum ProductType {
  SUNGLASSES = 'sunglasses',
  EYEGLASSES = 'eyeglasses',
  EVERGLASSES = 'everglasses',
  ACCESSORIES = 'accessories',
  CLIP_ON = 'clip on',
}

export interface StoreInformation {
  storeId: number
  catalogID: number
  environment: Environment
  region: Region
  country: string
  timeZone: number
  timestamp: number
  lang: string
  langID: number
  currency: string
  ecomm: boolean
  user: User
  cart: Cart
  touchDevice: boolean
  pageType: PageType
  pageName: string
  productType: ProductType | string
  homePageURL: string
}
